import T from 'i18n-react'
import P from 'helpers/predicates'
import * as R from 'ramda'
import getSliderSelectors from 'containers/Form/Slider/selectors'
import {
  entitySelector
} from 'containers/Entity/selectors'
import {
  createSelectorWithPath,
} from 'helpers/ComponentSelectorUtil'
import {
  createSelector
} from 'reselect'

const riskStateSelector = state => state.risks
  ? state.risks
  : []

const riskSourceSelector = (riskSelector) => createSelector(
  entitySelector,
  riskSelector,
  (entities, refs) => R.compose(
    R.filter(R.propEq('risk', 'Risk')),
    R.map(({ type, id }) => entities[type][id])
  )(refs)
)

const isNotEmpty = R.compose(
  R.not,
  R.isEmpty
)

const isNotRisk = R.curry((value, risks) => R.both(
  isNotEmpty,
  R.any((risk) => P.between(risk.min, risk.max)(value))
)(risks))

const isRiskSelectorHoc = (riskSelector, valueSelector) => createSelector(
  valueSelector,
  riskSelector,
  (value, risks) => isNotRisk(value, risks)
)

export default (path) => {
  const withPath = createSelectorWithPath(path)
  const riskRefSelector = withPath(riskStateSelector)
  const riskSelector = riskSourceSelector(riskRefSelector)
  const { valueSelector } = getSliderSelectors(path)
  const isRiskSelector = isRiskSelectorHoc(riskSelector, valueSelector)

  return {
    riskSelector,
    isRiskSelector
  }
}
